import React from 'react';

import NavigationSections from './NavigationSections.js';
import NavigationLink from './NavigationLink.js';
import NavigationLoginButton from './NavigationLoginButton.js';
import { frontendConfig } from '../../../../../core/config/frontend.server.js';

interface NavigationMenuProps {
  hasSession: boolean;
  isMobile: boolean;
  activeSection: string;
  isHermesApp?: boolean;
}

const { cdnUrlInternal } = frontendConfig;

const NavigationMenu: React.FC<NavigationMenuProps> = ({
  hasSession,
  isMobile,
  isHermesApp,
  activeSection,
}) => (
  <div className="menu">
    {isMobile && <NavigationSections activeSection={activeSection} />}
    <NavigationLoginButton
      hasSession={hasSession}
      activeSection={activeSection}
    />
    {!isHermesApp && (
      <NavigationLink
        className="aftenposten"
        location="https://www.ap.no"
        name="Aftenposten"
        imgUrl={`${cdnUrlInternal}/vink/images/header/v2/ap.svg`}
        activeSection={activeSection}
      />
    )}
  </div>
);

export default NavigationMenu;
